import React from 'react'

import Loader from '../../components/Loader'
import SubNav from '../../components/SubNav'
import Profile from './Profile'
import Verification from './Verification'
import More from './More'

import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'

function TabPanel(props) {
  	const { children, value, index, ...other } = props;
  	return (
    	<div role='tabpanel' hidden={value !== index} id={`nav-tabpanel-${index}`} {...other} >
      	{value === index && ( children )}
    	</div>
  	)
}

class GroupSettingsContainer extends React.Component {
	state = {
	 	loading:false,
		activeTab: 0
  	}
  	handleChange = (event, newValue) => {
  		this.setState({activeTab:newValue})
  	}
  	render() {
  		const {loading, activeTab} = this.state
    	return (
   		<React.Fragment>
   		<Loader loading={loading}/>
   		<Container maxWidth='lg' style={{ padding: 10, marginBottom: 50 }}>
				<Grid container justify='center' spacing={2}>
					<Grid item xs={12} sm={12} md={10} >
						<SubNav text='Group Settings'/>
					
						<div style={{borderBottom: '2px solid #eee'}}>  
						  	<Tabs
						    	value={activeTab}
						    	variant="fullWidth"
						    	onChange={this.handleChange}
						    	indicatorColor="primary"
						    	textColor="primary"							    
						  	>
						    	<Tab label='Profile' />
						    	<Tab label='Verification' />
						    	<Tab label='More' />
						  	</Tabs>
						</div>

						<TabPanel value={activeTab} index={0}>
				        	<Profile/>
				      </TabPanel>
				      <TabPanel value={activeTab} index={1}>
				        	<Verification/>
				      </TabPanel>
				      <TabPanel value={activeTab} index={2}>
				        	<More/>
				      </TabPanel>

					</Grid>
				</Grid>
			</Container>
   		</React.Fragment>
    	)
  	}
}
export default GroupSettingsContainer
